import { render, staticRenderFns } from "./DictionaryFilter.vue?vue&type=template&id=5ee97732&"
import script from "./DictionaryFilter.vue?vue&type=script&lang=js&"
export * from "./DictionaryFilter.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryFilter.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports